import React, {
  createContext,
  useCallback,
  useContext,
  useMemo,
  useRef,
} from 'react';

const Context = createContext();

export const useEventEmmiter = () => useContext(Context);

export const EventEmmiterProvider = ({ children }) => {
  const subscribersRef = useRef(new Map()); // name -> Set(callbacks)

  const notify = useCallback((name, state) => {
    const subscribers = subscribersRef.current.get(name);

    if (subscribers) {
      subscribers.forEach((cb) => cb(state));
    }
  }, []);

  const subscribe = useCallback((name, cb) => {
    if (!subscribersRef.current.has(name)) {
      subscribersRef.current.set(name, new Set());
    }
    const subscribers = subscribersRef.current.get(name);
    subscribers.add(cb);
    return () => subscribers.delete(cb);
  }, []);

  const value = useMemo(() => ({ notify, subscribe }), [notify, subscribe]);

  return <Context.Provider value={value}>{children}</Context.Provider>;
};
